import React from 'react';
import { ILineup } from './types';
import { BootLineupContext } from './context/LineupContext';
import { LineupInner } from './ui/LineupInner';
import { MockedLineupContext } from './context/MockedLineupContext';

const Lineup: React.FC<{lineup: ILineup, mock?: boolean, authToken: string}> = ({lineup, mock, authToken}) => {
  return mock
    ? <MockedLineupContext authToken="todo" id={lineup.id} initialLineup={lineup} initialOptions={undefined}>
        <LineupInner />
      </MockedLineupContext>
    : <BootLineupContext authToken={authToken} id={lineup.id} initialLineup={lineup} initialOptions={undefined}>
        <LineupInner />
      </BootLineupContext>  
}

export default Lineup
